/**
 * The chips that make the active filter state visible.
 *
 * A KPI card that silently narrows a table is worse than no filter at all: the
 * reader sees a short list and has no way to tell whether that is all the data or
 * a slice of it. Every active narrowing therefore shows up here as a named chip
 * with its own remove control, plus one "clear everything".
 *
 * Chips are the readable projection of the page's filter state, not a second copy
 * of it — the page passes what is active and how to clear each one.
 */
import React from "react";
import { X } from "lucide-react";

export default function BexioActiveFilters({ chips, onClearAll }) {
  const active = (chips || []).filter(Boolean);
  if (active.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs text-muted-foreground">Aktive Filter:</span>
      {active.map((c) => (
        <span
          key={c.key}
          className="inline-flex items-center gap-1 rounded-full border border-primary bg-primary/10 py-0.5 pl-2.5 pr-1 text-xs font-medium text-primary"
        >
          {c.label}
          <button
            type="button"
            onClick={c.onRemove}
            aria-label={`Filter „${c.label}“ entfernen`}
            className="rounded-full p-0.5 hover:bg-primary/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <X aria-hidden="true" className="h-3 w-3" />
          </button>
        </span>
      ))}
      {active.length > 1 && onClearAll ? (
        <button
          type="button"
          onClick={onClearAll}
          className="rounded text-xs font-medium text-muted-foreground underline hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          Alle entfernen
        </button>
      ) : null}
    </div>
  );
}
